<script lang="ts">
  import CategorySection from './CategorySection.svelte'
  import filters from '../lib/stores/filters'
  import type { Filter } from '../global'
  import Label from './Label.svelte'

  export let label: string
  export let options: Filter.Option[]
</script>

<CategorySection>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
    <Label class="block" for="room-type">
      {label}
    </Label>
    <div class="flex">
      <select
        name="pokoj"
        id="room-type"
        class="select basis-full sm:basis-auto"
        bind:value={$filters.roomType}
      >
        {#each options as { value, text }}
          <option {value}>{text}</option>
        {/each}
      </select>
    </div>
  </div>
</CategorySection>
